import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ValidationService {
    email: any = (c: any) => {
        const regexp = new RegExp(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
        // any component logic here
        if (!regexp.test(String(c.value).toLowerCase())) {
            return { ['invalidEmail']: true };
        }
    };

    password: any = (c: any) => {
        if (c.value?.length < 8 || c.value?.length > 32) {
            return { ['isValidPassword']: true };
        }

        const regexp = new RegExp(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.\[\]{}()?"!@#%&/\\,><':;|_~`])\S{8,99}$/,
        );

        if (!c.value?.match(regexp)) {
            return { ['isValidPassword_notStrong']: true };
        }
    };

    phone: any = (c: any) => {

        const regexp = new RegExp(/^\+[1-9]\d{1,14}$/);
        if (!regexp.test(String(c.value))) {
            return { ['isValidPhone']: true };
        }
    };

    firstName: any = (c: any) => {
        if (c.value?.length > 50) {
            return { ['isValidFirstName']: true };
        }
    };

    lastName: any = (c: any) => {
        if (c.value?.length > 50) {
            return { ['isValidLastName']: true };
        }
    };

    roomNumber: any = (c: any) => {
        if (c.value?.length > 50) {
            return { ['isValidRoomNumber']: true };
        }
    };

    logAvailable: any = (c: any) => {
        if (c.value < 0) {
            return { ['isValidLogAvailable']: true };
        }
    };

    fullName: any = (c: any) => {
        if (c.value?.length > 50) {
            return { ['isValidFullName']: true };
        }
    };
}
